import { useAppDispatch } from 'store/store';
import { loadingActions } from 'store';
import toast from 'shared/utils/toast';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { typeService } from 'shared/services';
import TypeForm from '../components/TypeForm';

const initType = {
  id: null,
  code: null,
  description: null
};

export const CreateType = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.type.new';

  const dispatch = useAppDispatch();

  const createType = async (values) => {
    dispatch(loadingActions.startLoading());
    typeService.add(values).then(() => {
      toast.crud.successCreate('Tipo');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <TypeForm type={initType} onSubmit={createType} />
    </TenantPage>
  );
};

export default CreateType;
